import {
    GET_ALL_MATRIX_DATA,
    SEARCH_ALL_MATRIX_USER,
    GET_ALL_DEPARTMENT,
    GET_ALL_DEPARTMENT_TEAMS,
    GET_ALL_MATRIX_MATCHING_DATA,
    MATRIX_START_COMPARE_LEFT_DATA,
    MATRIX_START_COMPARE_RIGHT_DATA,
    MATRIX_SEARCH_SKILLS
} from "../Actions/matrix";

import {
    API,
    SITE_API,
    GET_ALL_MATRIX_DATA_URL,
    SEARCH_ALL_MATRIX_USER_URL,
    GET_ALL_DEPARTMENT_URL,
    GET_ALL_DEPARTMENT_TEAMS_URL,
    GET_ALL_MATRIX_MATCHING_DATA_URL,
    MATRIX_START_COMPARE_LEFT_DATA_URL,
    MATRIX_START_COMPARE_RIGHT_DATA_URL,
    MATRIX_SEARCH_SKILLS_URL
} from "../variable";

import axios from "axios";

const state = {
};

const mutations = {

};

const actions = {
    [MATRIX_SEARCH_SKILLS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + MATRIX_SEARCH_SKILLS_URL,
            method: "POST",
            data: payload,
            headers: { Authorization: "Bearer " + sessionStorage.siteAuthToken }
        });
    },
    [MATRIX_START_COMPARE_RIGHT_DATA]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + MATRIX_START_COMPARE_RIGHT_DATA_URL,
            method: "POST",
            data: payload,
            headers: { Authorization: "Bearer " + sessionStorage.siteAuthToken }
        });
    },
    [MATRIX_START_COMPARE_LEFT_DATA]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + MATRIX_START_COMPARE_LEFT_DATA_URL,
            method: "POST",
            data: payload,
            headers: { Authorization: "Bearer " + sessionStorage.siteAuthToken }
        });
    },
    [GET_ALL_MATRIX_MATCHING_DATA]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + GET_ALL_MATRIX_MATCHING_DATA_URL,
            method: "POST",
            data: payload,
            headers: { Authorization: "Bearer " + sessionStorage.siteAuthToken }
        });
    },
    [GET_ALL_DEPARTMENT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + GET_ALL_DEPARTMENT_URL,
            method: "POST",
            data: payload,
            headers: { Authorization: "Bearer " + sessionStorage.siteAuthToken }
        });
    },
    [GET_ALL_DEPARTMENT_TEAMS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + GET_ALL_DEPARTMENT_TEAMS_URL,
            method: "POST",
            data: payload,
            headers: { Authorization: "Bearer " + sessionStorage.siteAuthToken }
        });
    },
    [SEARCH_ALL_MATRIX_USER]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + SEARCH_ALL_MATRIX_USER_URL,
            method: "POST",
            data: payload,
            headers: { Authorization: "Bearer " + sessionStorage.siteAuthToken }
        });
    },
    [GET_ALL_MATRIX_DATA]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: SITE_API + GET_ALL_MATRIX_DATA_URL,
            method: "POST",
            data: payload,
            headers: { Authorization: "Bearer " + sessionStorage.siteAuthToken }
        });
    },
};

const getters = {

};
export default {
    mutations,
    actions,
    getters,
    state
};